import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject16() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n\t", ";\n"]);

  _templateObject16 = function () {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteralLoose(["\n\t&[data-active='true'] {\n\t\t", ";\n\t\t", ";\n\n\t\tbackground: ", ";\n\t\tborder-color: ", ";\n\t\tcolor: ", ";\n\n\t\t&:hover {\n\t\t\tbackground: ", ";\n\t\t}\n\t\t&:focus {\n\t\t\tbackground: ", ";\n\t\t\tbox-shadow: ", ";\n\t\t\tborder-color: ", ";\n\t\t}\n\t\t&:active {\n\t\t\tbackground: ", ";\n\t\t}\n\t}\n"]);

  _templateObject15 = function () {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n\tbackground: none;\n\tborder-color: transparent;\n\tcolor: ", ";\n\n\t&:hover,\n\t&:active,\n\t&:focus,\n\t&[data-focused='true'] {\n\t\tbackground-color: transparent;\n\t\ttext-decoration: underline;\n\t}\n\n\t&:active {\n\t\tcolor: ", ";\n\t}\n\n\t&[data-destructive='true'] {\n\t\tcolor: ", ";\n\n\t\t&:active {\n\t\t\tcolor: ", ";\n\t\t}\n\t}\n"]);

  _templateObject14 = function () {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteralLoose(["\n\tbackground: none;\n\tborder-color: transparent;\n\tcolor: ", ";\n\n\t&:active {\n\t\tcolor: ", ";\n\t}\n\n\t&[data-destructive='true'] {\n\t\tcolor: ", ";\n\n\t\t&:active {\n\t\t\tcolor: ", ";\n\t\t}\n\t}\n"]);

  _templateObject13 = function () {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteralLoose(["\n\tbackground-color: ", ";\n\tborder-color: ", ";\n\tcolor: ", ";\n\n\t&:hover {\n\t\tbackground-color: ", ";\n\t\tborder-color: ", ";\n\t}\n\n\t&:focus,\n\t&[data-focused='true'] {\n\t\tbackground-color: ", ";\n\t\tborder-color: ", ";\n\t\tcolor: ", ";\n\t}\n\n\t&:active {\n\t\tbackground-color: ", ";\n\t\tborder-color: ", ";\n\t\tcolor: ", ";\n\t}\n\n\t&[data-destructive='true'] {\n\t\tcolor: ", ";\n\n\t\t&:hover,\n\t\t&:focus {\n\t\t\tborder-color: ", ";\n\t\t}\n\n\t\t&:active {\n\t\t\tcolor: ", ";\n\t\t}\n\t}\n"]);

  _templateObject12 = function () {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteralLoose(["\n\tbackground-color: ", ";\n\tborder-color: ", ";\n\tcolor: ", ";\n\n\t&:hover {\n\t\tbackground-color: ", ";\n\t\tborder-color: ", ";\n\t}\n\n\t&:focus,\n\t&[data-focused='true'] {\n\t\tbackground-color: ", ";\n\t\tborder-color: ", ";\n\t\tcolor: ", ";\n\t}\n\n\t&:active {\n\t\tbackground-color: ", ";\n\t\tborder-color: ", ";\n\t\tcolor: ", ";\n\t}\n\n\t&[data-destructive='true'] {\n\t\tborder-color: ", ";\n\t\tcolor: ", ";\n\n\t\t&:hover,\n\t\t&:active,\n\t\t&:focus,\n\t\t&[data-focused='true'] {\n\t\t\tborder-color: ", ";\n\t\t\tcolor: ", ";\n\t\t}\n\n\t\t&:active {\n\t\t\tcolor: ", ";\n\t\t}\n\t}\n"]);

  _templateObject11 = function () {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n\tbackground-color: ", ";\n\tborder-color: ", ";\n\tcolor: ", ";\n\n\t&:active {\n\t\tcolor: ", ";\n\t}\n\n\t&:hover {\n\t\tbackground-color: ", ";\n\t\tborder-color: ", ";\n\t\tcolor: ", ";\n\t}\n\n\t&:focus,\n\t&[data-focused='true'] {\n\t\tbackground-color: ", ";\n\t\tborder-color: ", ";\n\t\tcolor: ", ";\n\t}\n\n\t&:active {\n\t\tbackground-color: ", ";\n\t\tborder-color: ", ";\n\t}\n\n\t&[data-destructive='true'] {\n\t\tbackground-color: ", ";\n\t\tborder-color: ", ";\n\n\t\t&:hover,\n\t\t&:focus,\n\t\t&[data-focused='true'] {\n\t\t\tbackground-color: ", ";\n\t\t\tborder-color: ", ";\n\t\t}\n\n\t\t&:active {\n\t\t\tbackground-color: ", ";\n\t\t}\n\t}\n"]);

  _templateObject10 = function () {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n"]);

  _templateObject9 = function () {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n\tmin-height: calc(", " / 2);\n\n\t&[data-icon='true'] {\n\t\tmin-width: ", ";\n\t}\n"]);

  _templateObject8 = function () {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n\tmin-height: calc(", " / 2);\n\n\t&[data-icon='true'] {\n\t\tmin-width: ", ";\n\t}\n"]);

  _templateObject7 = function () {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n\tmin-height: calc(", " / 2);\n\n\t&[data-icon='true'] {\n\t\tmin-width: ", ";\n\t}\n"]);

  _templateObject6 = function () {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n\tmin-height: ", ";\n\n\t&[data-icon='true'] {\n\t\tmin-width: ", ";\n\t}\n"]);

  _templateObject5 = function () {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n\tmin-height: ", ";\n\n\t&[data-icon='true'] {\n\t\tmin-width: ", ";\n\t}\n"]);

  _templateObject4 = function () {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n\tmin-height: ", ";\n\n\t&[data-icon='true'] {\n\t\tmin-width: ", ";\n\t}\n"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tmin-height: ", ";\n\n\t&[data-icon='true'] {\n\t\tmin-width: ", ";\n\t}\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tcolor: ", ";\n\tfont-weight: 600;\n\tpadding-left: ", ";\n\tpadding-right: ", ";\n\n\t&:active {\n\t\tcolor: ", ";\n\t}\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css, ui } from '@wp-g2/styles';
import * as baseButtonStyles from '../BaseButton/BaseButton.styles';
export var Button = css(_templateObject(), ui.get('buttonTextColor'), ui.get('buttonPaddingX'), ui.get('buttonPaddingX'), ui.get('buttonTextColorActive'));
export var large = css(_templateObject2(), ui.get('controlHeightLarge'), ui.get('controlHeightLarge'));
export var small = css(_templateObject3(), ui.padding.x(ui.get('controlPaddingX')), ui.get('controlHeightSmall'), ui.get('controlHeightSmall'));
export var xSmall = css(_templateObject4(), ui.padding.x(ui.get('controlPaddingXSmall')), ui.get('controlHeightXSmall'), ui.get('controlHeightXSmall'));
export var xxSmall = css(_templateObject5(), ui.padding.x(ui.get('controlHeightXXSmall')), ui.get('controlHeightXXSmall'), ui.get('controlHeightXXSmall'));
export var half = css(_templateObject6(), ui.get('controlHeight'), ui.get('controlHeight'));
export var halfLarge = css(_templateObject7(), ui.get('controlHeightLarge'), ui.get('controlHeightLarge'));
export var halfSmall = css(_templateObject8(), ui.get('controlHeightSmall'), ui.get('controlHeightSmall'));
export var icon = css(_templateObject9(), ui.padding(0));
export var primary = css(_templateObject10(), ui.get('buttonPrimaryColor'), ui.get('buttonPrimaryBorderColor'), ui.get('buttonPrimaryTextColor'), ui.get('buttonPrimaryTextColorActive'), ui.get('buttonPrimaryColorHover'), ui.get('buttonPrimaryBorderColorHover'), ui.get('buttonPrimaryTextColorHover'), ui.get('buttonPrimaryColorFocus'), ui.get('buttonPrimaryBorderColorFocus'), ui.get('buttonPrimaryTextColorFocus'), ui.get('buttonPrimaryColorActive'), ui.get('buttonPrimaryBorderColorActive'), ui.color.destructive, ui.color.destructive, ui.color.destructive, ui.color.destructive, ui.color.text);
export var secondary = css(_templateObject11(), ui.get('buttonSecondaryColor'), ui.get('buttonSecondaryBorderColor'), ui.get('buttonSecondaryTextColor'), ui.get('buttonSecondaryColorHover'), ui.get('buttonSecondaryBorderColorHover'), ui.get('buttonSecondaryColorFocus'), ui.get('buttonSecondaryBorderColorFocus'), ui.get('buttonSecondaryTextColorFocus'), ui.get('buttonSecondaryColorActive'), ui.get('buttonSecondaryBorderColorActive'), ui.get('buttonSecondaryTextColorActive'), ui.color.destructive, ui.color.destructive, ui.color.destructive, ui.color.destructive, ui.color.text);
export var tertiary = css(_templateObject12(), ui.get('buttonTertiaryColor'), ui.get('buttonTertiaryBorderColor'), ui.get('buttonTertiaryTextColor'), ui.get('buttonTertiaryColorHover'), ui.get('buttonTertiaryBorderColorHover'), ui.get('buttonTertiaryColorFocus'), ui.get('buttonTertiaryBorderColorFocus'), ui.get('buttonTertiaryTextColorFocus'), ui.get('buttonTertiaryColorActive'), ui.get('buttonTertiaryBorderColorActive'), ui.get('buttonTertiaryTextColorActive'), ui.color.destructive, ui.color.destructive, ui.color.text);
export var link = css(_templateObject13(), ui.get('linkColor'), ui.get('linkColorActive'), ui.color.destructive, ui.color.text);
export var plainLink = css(_templateObject14(), ui.padding.x(0), ui.get('linkColor'), ui.get('linkColorActive'), ui.color.destructive, ui.color.text);
export var subtle = baseButtonStyles.subtle;
export var control = baseButtonStyles.control;
var subtleControlActiveTransition = css({
  transition: ['all', ui.get('transitionDuration'), ui.get('transitionTimingFunctionControl')].join(' ')
});
export var subtleControlActive = css(_templateObject15(), subtleControlActiveTransition, ui.zIndex('ControlFocus'), ui.get('buttonControlActiveStateColor'), ui.get('buttonControlActiveStateColor'), ui.get('buttonControlActiveStateTextColor'), ui.get('buttonControlActiveStateColorHover'), ui.get('buttonControlActiveStateColorFocus'), ui.get('buttonControlActiveStateBoxShadowFocus'), ui.get('buttonControlActiveStateBorderColorFocus'), ui.get('buttonControlActiveStateColorActive'));
export var subtleControl = css(_templateObject16(), baseButtonStyles.subtleControl, subtleControlActive);
export var currentColor = baseButtonStyles.currentColor;